<template>
    <span :class="computedClass">{{ relativeTime }}</span>
  </template>
  
  <script>
  import moment from "moment";
  
  export default {
    props: {
      datetime: {
        type: [String, Date],
        required: true
      },
      highlightFuturePast: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        relativeTime: "", // Inicializar el tiempo relativo
        intervalId: null
      };
    },
    computed: {
      // Agrega la clase según si la fecha es futura o pasada
      computedClass() {
        if (!this.highlightFuturePast) return "";
        const time = moment.utc(this.datetime);
        return time.isAfter(moment.utc()) ? "text-success" : "text-danger";
      }
    },
    watch: {
      // Si `datetime` cambia, recalcula el tiempo relativo
      datetime: {
        immediate: true,
        handler() {
          this.updateRelativeTime();
        }
      }
    },
    mounted() {
      this.startUpdating();
    },
    beforeDestroy() {
      this.stopUpdating();
    },
    methods: {
      updateRelativeTime() {
        const time = moment.utc(this.datetime);
        this.relativeTime = time.isValid() ? time.fromNow() : "Invalid date";
      },
      startUpdating() {
        this.updateRelativeTime(); // Actualizar inmediatamente al montar
        this.intervalId = setInterval(() => {
          this.updateRelativeTime();
        }, 60000); // Actualiza cada minuto
      },
      stopUpdating() {
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .text-success {
    color: green;
  }
  .text-danger {
    color: red;
  }
  </style>
  